import React, { useRef, useEffect } from 'react';
import '../css/remixicon/remixicon.css'; 

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import tech1 from '../img/tech-icon-1.png';
import tech2 from '../img/tech-icon-2.png';
import tech3 from '../img/tech-icon-3.png';
import tech4 from '../img/tech-icon-4.png';
import techBg from '../img/symbol.png';
import techSource from '../img/AdobeStock_915838054_Video_HD_Preview.mp4';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Tech = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                // console.error("Video playback failed:", error);
            });
        }
    }, []);

    return(
        <div className="flex-1">
            <section className="page_title tech">
                <div className="page_title_bg tech"></div>
                <div className="page_title_text">
                   <h2>보유기술</h2>
                    <p>위즈팩토리는 끊임없이 노력합니다.</p>
                </div>
            </section>
            <section className="tech">
                <div className="area">
                    <div className="main-title">
                        <h3>위즈팩토리 보유 기술</h3>
                        <p>사물 인터넷(IoT), 빅데이터 및 분석, 인공지능(AI) 및 머신 러닝, 사이버-물리 시스템(CPS), 클라우드 컴퓨팅 등 첨단 기술을 통합하여 제조업체가 효율성을 극대화하고, 비용을 절감하며, 제품 품질을 향상 시키는데 연구 및 개발 투자를 적극적으로 하고 있습니다.</p>
                    </div>
                    <div className="main-cont">
                        <div className="feature-wrap">
                            <div className="feature-item-side tech">
                                <div className="feature-item tech-line line-1">
                                    <img src={tech1} alt=''/>
                                    <h3>신기술 연구 및 탐색</h3>
                                    <p>새로운 프로그래밍 언어, 프레임워크, 라이브러리, 알고리즘 등을 연구하고 이를 기반으로 혁신적인 소프트웨어 솔루션을 개발하고 있습니다.</p>
                                </div>
                                <div className="feature-item tech-line line-2">
                                    <img src={tech2} alt=''/>
                                    <h3>프로토타입 개발 및 테스팅</h3>
                                    <p>새로운 아이디어나 기술을 검증하기 위해 프로토타입을 개발하고 이를 통해 실제 사용환경에서의 성능과 사용자반응을 테스트합니다.</p>
                                </div>
                            </div>
                            <div className="tech-img">
                                <video ref={videoRef} className="video-bg" poster={techBg} autoPlay loop muted playsInline>
                                    <source src={techSource} type="video/mp4" />
                                </video>
                                <div className="tech-frame"></div>
                            </div>

                            <div className="feature-item-side tech">
                                <div className="feature-item tech-line line-3">
                                    <img src={tech3} alt=''/>
                                    <h3>제품 개발 및 개선</h3>
                                    <p>기존 제품의 기능 개선, 사용자 인터페이스(UI) 개선, 사용자 경험(UX) 최적화, 성능 향상 등을 통해 사용자 피드백을 적극적으로 수집하고 분석하여 제품 개발방향을 결정합니다.</p>
                                </div>
                                <div className="feature-item tech-line line-4">
                                    <img src={tech4} alt=''/>
                                    <h3>시장 및 기술 트렌드 분석</h3>
                                    <p>지속적인 시장조사와 기술 트렌드분석을 통해 새로운 기술 발전방향과 시장의 수요를 파악하여 연구개발활동의 방향성을 결정하고, 장기적인 기술로드맵을 수립합니다.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Tech;